import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextToiTeaser from '@contexts/toiTeaser'
import { TOITeaserLayoutContextType } from '@contexts/toiTeaser'
import { AppendingContentWrapperProps } from '@widgets/Teaser/toi/types'
import { layout, desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'

interface StyledAppendingContextWrapperProps
  extends Pick<AppendingContentWrapperProps, 'hideOnMobile'> {
  alignment: TOITeaserLayoutContextType['mainTextAlignment']['h']
  extraMargin?: boolean
}

const { TOITeaserLayoutContext } = contextToiTeaser

const {
  desktop: { minWidth: minWidthDesktop },
  tablet: { minWidth: minWidthTablet },
} = layout

const StyledAppendingContextWrapper = styled.div<StyledAppendingContextWrapperProps>`
  ${({
    theme: {
      colors: {
        grey: { grey_100 },
      },
    },
    alignment,
    hideOnMobile,
    extraMargin,
  }) => {
    const cornerPaddingDesktop = `${Math.round(
      (1.6 / 100) * minWidthDesktop
    )}px`

    const cornerPaddingTablet = `${Math.round((1.6 / 100) * minWidthTablet)}px`

    const cornerPaddingMobile = '3.7vw'
    return css`
      position: relative;
      width: 100%;
      box-sizing: border-box;
      background-color: ${grey_100};
      ${desktopCSS(css`
        ${!hideOnMobile &&
        css`
          display: none;
        `}
        padding: ${extraMargin ? `calc(${cornerPaddingDesktop} /2)` : '0'}
          ${alignment === 'right'
          ? `calc(${cornerPaddingDesktop} + 8px)`
          : cornerPaddingDesktop}
          ${cornerPaddingDesktop}
          ${alignment === 'left'
          ? `calc(${cornerPaddingDesktop} + 8px)`
          : cornerPaddingDesktop};
      `)}

      ${tabletCSS(css`
        ${!hideOnMobile &&
        css`
          display: none;
        `}
        padding: ${extraMargin ? `calc(${cornerPaddingTablet} /2)` : '0'}
          ${alignment === 'right'
          ? `calc(${cornerPaddingTablet} + 8px)`
          : cornerPaddingTablet}
          ${cornerPaddingTablet}
          ${alignment === 'left'
          ? `calc(${cornerPaddingTablet} + 8px)`
          : cornerPaddingTablet};
      `)}

      ${mobileCSS(css`
        padding: ${extraMargin ? `calc(${cornerPaddingMobile} /2)` : '0'}
          ${alignment === 'right'
            ? `calc(${cornerPaddingMobile} + 8px)`
            : cornerPaddingMobile}
          ${cornerPaddingMobile}
          ${alignment === 'left'
            ? `calc(${cornerPaddingMobile} + 8px)`
            : cornerPaddingMobile};
      `)}
    `
  }}
`

const AppendingContentWrapper: FunctionComponent<
  AppendingContentWrapperProps
> = ({ hideOnMobile, extraMargin, children }) => {
  const { mainTextAlignment } = useContext(TOITeaserLayoutContext)

  return (
    <StyledAppendingContextWrapper
      alignment={mainTextAlignment['h']}
      hideOnMobile={hideOnMobile}
      extraMargin={extraMargin}>
      {children}
    </StyledAppendingContextWrapper>
  )
}

export default AppendingContentWrapper
